/**
 *
 * Callback
 *
 */

import React, { useEffect, useRef } from 'react';
import LoadingIndicator from 'components/LoadingIndicator';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';
import Auth from 'auth0-react';

const Callback = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();
  const logoutRedirect = useRef<NodeJS.Timeout | null>(null);
  const auth = new Auth();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const state = searchParams.get('state');
    const connection = searchParams.get('connection');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    // Wait for auth0 to decide if user is authenticated or not
    if (!isLoading) {
      if (isAuthenticated) {
        if (logoutRedirect.current) clearTimeout(logoutRedirect.current);
        auth.handleAuthentication(true);
      } else if (!state && connection) {
        // IdP-initiated login handling - this shouldn't happen with our setup but keeping for completeness
        loginWithRedirect({
          authorizationParams: {
            connection,
          },
        });
      } else {
        // Authentication failed - logout after timeout
        logoutRedirect.current = setTimeout(() => {
          const errorMessage = error ? `${error}: ${errorDescription}` : '';
          auth.logout(errorMessage);
          clearTimeout(logoutRedirect.current as NodeJS.Timeout);
        }, 1000);
      }
    }

    return () => {
      if (logoutRedirect.current) {
        clearTimeout(logoutRedirect.current);
      }
    };
  }, [isAuthenticated, isLoading, location]);

  return (
    <div style={{ width: '100vw' }}>
      <LoadingIndicator text="Logging in" />
    </div>
  );
};

export default Callback;
